import { CircularProgress, LinearProgress } from '@mui/material';
import Box from '@mui/material/Box';
import useWidth from '../../../../Hooks/useWidth';

interface LoadingOptionsProps {
  isLoading: boolean;
  hasData: boolean;
}

const LoadingOptions = ({ isLoading, hasData }: LoadingOptionsProps) => {
  const { mobileWidth } = useWidth();

  if (!isLoading) {
    return null;
  }

  return (
    <>
      {hasData || !mobileWidth ? (
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            top: 0,
            left: 0,
            zIndex: 999,
          }}
        >
          <LinearProgress />
        </Box>
      ) : (
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default LoadingOptions;
